<template>
  <div class="exchange-mall-notice-bar"
       :class="{ 'type-invite': type === 'invite' }"
       @click="handleToCoinDetail"
  >
    <ym-icon v-if="type === 'mall'"
             class="exchange-mall-notice-bar-icon"
             name="em-notice-bar"
    />
    <ym-img v-else
            class="exchange-mall-notice-bar-icon-img"
            :src="require('@/assets/img/million_read/invite/notice_icon.png')"
    />
    <!-- eslint-disable max-len -->
    <ym-swipe class="exchange-mall-notice-bar-list"
              :options="swiperOption"
              ref="swiper"
    >
      <ym-swipe-slide class="exchange-mall-notice-bar-list-item"
                      :class="{ 'type-invite': type === 'invite' }"
                      v-for="(item, index) in list"
                      :key="index"
                      v-ym-report:EXCHANGE_MALL_NOTICICATION_EXPOSURE="{
                        notification: item.content,
                        index,
                        page: routeName,
                      }"
      >
        <span class="exchange-mall-notice-bar-list-item-text ym-line-ellipsis"
              v-html="item.content"
        ></span>
      </ym-swipe-slide>
    </ym-swipe>
    <!-- eslint-disable max-len -->
  </div>
</template>

<script>
  import { swiper, swiperSlide } from 'vue-awesome-swiper';
  import { before, decorator } from 'ym-reporter-vue';
  import { locationPath } from '@/utils';

  export default {
    name: 'ExchangeMallNoticeBar',
    components: {
      'ym-swipe': swiper,
      'ym-swipe-slide': swiperSlide,
    },
    props: {
      list: {
        type: Array,
        required: true,
      },
      type: {
        type: String,
        default: 'mall',
      },
    },
    data() {
      return {
        swiperOption: {
          slidesPerView: 'auto',
          direction: 'vertical',
          loop: true,
          autoplay: {
            delay: 2500,
          },
        },
        currentIndex: 0,
      };
    },
    computed: {
      routeName() {
        if (this.$route.name === 'ExchangeMallHome') return '商城首页';
        return '';
      },
      swiperRefs() {
        if (this.$refs.swiper) {
          return this.$refs.swiper.swiper;
        }
        return null;
      },
    },
    methods: {
      fetchCurrSlider() {
        if (this.list.length === 1) return this.list[0];
        const { swiperRefs, swiperOption } = this;
        const { loop } = swiperOption;
        const { realIndex, clickedIndex } = swiperRefs;
        const currentIndex = loop ? realIndex : clickedIndex;
        this.currentIndex = currentIndex;
        return this.list.find((i, index) => index === currentIndex);
      },
      @decorator(before(function () {
        const item = this.fetchCurrSlider();
        this.$reporter.report('EXCHANGE_MALL_NOTICICATION_CLICK', {
          notification: item.content,
          index: this.currentIndex,
          page: this.routeName,
        });
      }))
      handleToCoinDetail() {
        if (this.type === 'mall') {
          locationPath('/exchange/mall/coin/raiders');
        }
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .exchange-mall-notice-bar {
    box-sizing: border-box;
    width: 91.5%;
    height: @size-large;
    margin: @size-base auto @size-extra-medium;
    padding-left: 24px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background: @background-color-lighter;
    border-radius: 15px;
    &.type-invite {
      width: 630px;
      height: 50px;
      background: #fcf3d9;
    }
    &-icon {
      margin-right: 16px;
      color: #576b95;
      font-size: 32px;
    }
    &-icon-img {
      margin-right: 10px;
      width: 38px;
      height: 32px;
    }
    &-list {
      height: 60px;
      margin: 0;
    }
    &-list-item {
      width: 600px;
      height: 60px;
      padding-right: 24px;
      display: flex;
      align-items: center;
      color: @color-text-light;
      font-size: @font-size-small;
      font-weight: @font-weight-strong;
      line-height: 1;
      &.type-invite {
        box-sizing: border-box;
        width: 560px;
        height: 60px;
      }
      &-text {
        width: 100%;
        /deep/ .highlight {
          color: #ff8500;
        }
      }
    }
  }

</style>
